import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../components-css/feedback.css';

const FeedbackForm = ({ entry, onSubmit }) => {
  const [formData, setFormData] = useState({ ...(entry ?? {}) });
  const [formErrors, setFormErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : type === 'file' ? files[0] : value,
    }));
    if (formErrors[name]) setFormErrors((prev) => ({ ...prev, [name]: null }));
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.bug && !formData.suggestion)
      errors.option = 'Please select either "Bug" or "Suggestion".';
    if (formData.bug) {
      if (!formData.bugLocation?.trim())
        errors.bugLocation = 'Please specify where the bug occurred.';
      if (!formData.reproduceSteps?.trim())
        errors.reproduceSteps = 'Please describe how to reproduce the bug.';
    }
    if (formData.suggestion && !formData.elaborateSuggestion?.trim())
      errors.elaborateSuggestion = 'Please elaborate on your suggestion.';
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    onSubmit(formData);
  };

  return (
    <div className="feedback-container">
      <div className="feedback-wrapper">

        <div className="feedback-header">
          <div className="feedback-eyebrow">Feedback</div>
          <h2 className="feedback-title">What's on your mind?</h2>
          <p className="feedback-subtitle">Tell us what's broken or what could be better.</p>
        </div>

        <div className="feedback-body">
          {formErrors.option && (
            <div className="error-alert">
              <p className="error-text">{formErrors.option}</p>
            </div>
          )}

          <div className="options-container">
            {/* Bug Option */}
            <label className="option-label bug-option">
              <input
                type="checkbox"
                name="bug"
                checked={formData.bug || false}
                onChange={handleInputChange}
                className="option-checkbox"
              />
              <span className="option-text">Report a Bug</span>
            </label>

            {formData.bug && (
              <div className="nested-fields animate-in">
                <div className="form-field">
                  <label className="field-label" htmlFor='bugLocation'>Which page or feature?</label>
                  <input
                    id="bugLocation"
                    type="text"
                    name="bugLocation"
                    value={formData.bugLocation || ''}
                    onChange={handleInputChange}
                    placeholder="e.g. Login page, Dashboard chart"
                    className="field-input"
                  />
                  {formErrors.bugLocation && (
                    <p className="field-error">{formErrors.bugLocation}</p>
                  )}
                </div>

                <div className="form-field">
                  <label className="field-label" htmlFor='reproduceSteps'>Steps to reproduce</label>
                  <textarea
                    id="reproduceSteps"
                    name="reproduceSteps"
                    value={formData.reproduceSteps || ''}
                    onChange={handleInputChange}
                    rows="4"
                    placeholder={"1. Go to…\n2. Click on…\n3. See error"}
                    className="field-textarea"
                  />
                  {formErrors.reproduceSteps && (
                    <p className="field-error">{formErrors.reproduceSteps}</p>
                  )}
                </div>
              </div>
            )}

            {/* Suggestion Option */}
            <label className="option-label suggestion-option" htmlFor="suggestion">
              <input
                id = "suggestion"
                type="checkbox"
                name="suggestion"
                checked={formData.suggestion || false}
                onChange={handleInputChange}
                className="option-checkbox"
              />
              <span className="option-text">Make a Suggestion</span>
            </label>

            {formData.suggestion && (
              <div className="nested-fields animate-in">
                <div className="form-field">
                  <label className="field-label" htmlFor='elaborateSuggestion'>Tell us more</label>
                  <textarea
                    id = "elaborateSuggestion"
                    name="elaborateSuggestion"
                    value={formData.elaborateSuggestion || ''}
                    onChange={handleInputChange}
                    rows="4"
                    placeholder="Share your ideas in as much detail as you'd like…"
                    className="field-textarea suggestion-textarea"
                  />
                  {formErrors.elaborateSuggestion && (
                    <p className="field-error">{formErrors.elaborateSuggestion}</p>
                  )}
                </div>
              </div>
            )}
          </div>

          <button type="submit" onClick={handleSubmit} className="fb-submit-button">
            <span>Send Feedback</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

      </div>
    </div>
  );
};

FeedbackForm.propTypes = {
  entry: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
};

export default FeedbackForm;